// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__19KWx","box":"WorkspacesBox_box__3ypCU","node":"WorkspacesBox_node__1f4ld"};